import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Divider,
	makeStyles,
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
	dialog: {
		"& .MuiPaper-root": {
			borderRadius: 8,
			padding: '32px 24px',
			minWidth: 320,
			maxWidth: 551,
		},
	},
	title: {
		fontFamily: "Roboto, sans-serif",
		fontWeight: 500,
		fontSize: "1.25rem",
		color: "rgba(0, 0, 0, 0.87)",
    padding: 0,
	},
  dialogContent: {
    padding: 0,
    marginTop: theme.spacing(2),
  },
	contentText: {
		fontFamily: "Roboto, sans-serif",
		fontSize: "0.95rem",
		color: "rgba(0, 0, 0, 0.6) !important",
		lineHeight: 1.5,
    margin: 0,
    "& strong": {
      fontWeight: 600,
    }
	},
	divider: {
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(4),
		backgroundColor: "#E0E0E0",
	},
	actions: {
		justifyContent: "center",
		padding: 0,
	},
	button: {
		borderColor: "#F80032",
		color: "#F80032",
		fontWeight: 500,
		padding: '8px 22px',
		textTransform: "uppercase",
		"&:hover": {
			backgroundColor: "rgba(248, 0, 50, 0.04)",
			borderColor: "#F80032",
		},
	},
}));

export const EtiquetaIndisponivelModal = ({ open, handleClose, message }) => {
	const classes = useStyles();
	const defaultMessage = "Houve um problema ao tentar imprimir a etiqueta. Por favor, tente novamente mais tarde.";

	return (
		<Dialog open={open} onClose={handleClose} className={classes.dialog}>
			<DialogTitle className={classes.title} disableTypography>
				Etiqueta não disponível
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<DialogContentText className={classes.contentText}>
					{message || defaultMessage}
				</DialogContentText>
				<Divider className={classes.divider} />
			</DialogContent>
			<DialogActions className={classes.actions}>
				<Button
					variant="outlined"
					onClick={handleClose}
					className={classes.button}
				>
					FECHAR
				</Button>
			</DialogActions>
		</Dialog>
	);
};
